// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.filters_old-container__86itn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.filters_old-container__86itn.filters_wrap__hRtNT {
  flex-wrap: wrap;
}
.filters_old-container__86itn .filters_box__94nP9.filters_col__PROjd {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.filters_old-container__86itn .filters_box__94nP9.filters_col__PROjd > div {
  width: 100%;
}
.filters_old-container__86itn .filters_box__94nP9.filters_row__WeqdW {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.filters_old-container__86itn form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.filters_old-container__86itn form > .filters_box__94nP9.filters_col__PROjd {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .filters_old-container__86itn form > .filters_box__94nP9.filters_col__PROjd {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .filters_old-container__86itn, .filters_col__PROjd, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .filters_old-container__86itn, .filters_col__PROjd, form {
    padding: 0px;
  }
}
.filters_text-overflow-hidden__2Xu21 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filters_icon__IV2wh {
  color: var(--accent-color);
}

.filters_richtext-output-wrap__wxiiZ .filters_se-video-container__9WpzJ figure {
  padding-bottom: 0 !important;
}

.filters_wrapper__c4mmK {
  width: 100%;
}
.filters_wrapper__c4mmK .filters_filterTitle__P598f {
  margin-bottom: 15px;
}
.filters_wrapper__c4mmK .filters_filterTitle__P598f p {
  font-size: 14px !important;
  font-weight: 400 !important;
}

.filters_active__BthXQ fieldset {
  border: none !important;
}

.filters_filterInput__HxdCg {
  height: 60px;
  background: #232323;
  border-radius: 10px;
}

.filters_nibSelectWithSearchInput__6Tuex {
  padding-top: 2px;
}

.filters_search__ZkTTj {
  padding: 15px;
  width: 100%;
  max-width: 100%;
}
.filters_search__ZkTTj input {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
}
@media screen and (max-width: 740px) {
  .filters_search__ZkTTj {
    min-width: auto;
  }
}

.filters_companySelect__hbAqm {
  padding-right: 3px;
}
.filters_companySelect__hbAqm input {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
}
.filters_companySelect__hbAqm .filters_MuiInputBase-root__bxSeN.filters_MuiOutlinedInput-root__Xfigs.filters_MuiAutocomplete-inputRoot__acJVe {
  border: none !important;
}
.filters_companySelect__hbAqm fieldset {
  border: 0;
}

.filters_date__M9w\\+N {
  padding: 15px;
  width: 100%;
}
.filters_date__M9w\\+N input {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
}

.filters_dateRange__542OV > div {
  background-color: #2F2F2F;
}
.filters_dateRange__542OV > div > div > div:first-of-type > div:nth-of-type(2) > div {
  background-color: #2F2F2F;
}
.filters_dateRange__542OV > div > div > div:first-of-type > div:nth-of-type(2) > div:nth-of-type(2) {
  background-color: #fff;
}
.filters_dateRange__542OV > div > div > div:first-of-type > div:nth-of-type(2) > div button span p {
  color: #fff;
}
.filters_dateRange__542OV > div > div > div:first-of-type > div:nth-of-type(2) > div button:disabled span p {
  color: #757575;
}
.filters_dateRange__542OV > div > div > div:first-of-type > div:nth-of-type(2) > div button:hover {
  background-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.04);
}
.filters_dateRange__542OV h6, .filters_dateRange__542OV svg, .filters_dateRange__542OV span {
  color: #fff;
}
.filters_dateRange__542OV div[role=button]:hover {
  background-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.04);
}

.filters_cursorPointer__u3qYY {
  cursor: pointer;
}

.filters_withMaterialBorder__QEptV {
  position: relative;
  padding: 0 10px;
  border-radius: 4px;
  border: none;
}
.filters_withMaterialBorder__QEptV:hover {
  border-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.5);
}
.filters_withMaterialBorder__QEptV.filters_active__BthXQ {
  border-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 1);
}

.filters_filterSelect__gc09X .filters_MuiInputBase-root__bxSeN.filters_MuiInput-root__sZVzI {
  width: 100%;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/NibFilters/filters.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAtEA;EACI,WAAA;AAyEJ;AAxEI;EACI,mBAAA;AA0ER;AAzEQ;EACI,0BAAA;EACA,2BAAA;AA2EZ;;AAzEI;EACI,uBAAA;AA4ER;;AA1EA;EACI,YAAA;EACA,mBAfM;EAgBN,mBAAA;AA6EJ;;AA3EA;EACI,gBAAA;AA8EJ;;AA5EA;EACI,aAAA;EACA,WAAA;EACA,eAAA;AA+EJ;AA9EI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAgFR;AA/EI;EATJ;IAUQ,eAAA;EAkFN;AACF;;AAjFA;EACI,kBAAA;AAoFJ;AAnFI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAqFR;AApFI;EACI,uBAAA;AAsFR;AArFI;EACI,SAAA;AAuFR;;AArFA;EACI,aAAA;EACA,WAAA;AAwFJ;AAvFI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAyFR;;AAtFI;EACI,yBD3CD;ACoIP;AArFoB;EACI,yBDhDjB;ACuIP;AAtFwB;EACI,sBAAA;AAwF5B;AAvFwB;EACI,WAAA;AAyF5B;AAxFwB;EACI,cAAA;AA0F5B;AAzFwB;EACI,iGAAA;AA2F5B;AA1FI;EACI,WAAA;AA4FR;AA3FI;EACI,iGAAA;AA6FR;;AA3FA;EACI,eAAA;AA8FJ;;AA5FA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AA+FJ;AA9FI;EACI,4FAAA;AAgGR;AA/FI;EACI,0FAAA;AAiGR;;AA7FI;EACI,WAAA;EACA,eAAA;AAgGR","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","\r\n@import \"../../../sass/_settings\"\r\n\r\n$bgColor: #232323\r\n\r\n.wrapper\r\n    width: 100%\r\n    .filterTitle\r\n        margin-bottom: 15px\r\n        p\r\n            font-size: 14px !important\r\n            font-weight: 400 !important\r\n.active\r\n    fieldset\r\n        border: none !important\r\n\r\n.filterInput\r\n    height: 60px\r\n    background: $bgColor\r\n    border-radius: 10px\r\n\r\n.nibSelectWithSearchInput\r\n    padding-top: 2px\r\n\r\n.search\r\n    padding: 15px\r\n    width: 100%\r\n    max-width: 100%\r\n    input\r\n        font-style: normal\r\n        font-weight: 400\r\n        font-size: 14px\r\n        line-height: 130%\r\n    @media screen and ( max-width: 740px )\r\n        min-width: auto\r\n\r\n.companySelect\r\n    padding-right: 3px\r\n    input\r\n        font-style: normal\r\n        font-weight: 400\r\n        font-size: 14px\r\n        line-height: 130%\r\n    .MuiInputBase-root.MuiOutlinedInput-root.MuiAutocomplete-inputRoot\r\n        border: none !important\r\n    fieldset\r\n        border: 0\r\n\r\n.date \r\n    padding: 15px\r\n    width: 100%\r\n    input\r\n        font-style: normal\r\n        font-weight: 400\r\n        font-size: 14px\r\n        line-height: 130%\r\n\r\n.dateRange\r\n    >div\r\n        background-color: $main\r\n        > div\r\n            > div:first-of-type\r\n                > div:nth-of-type(2)\r\n                    > div\r\n                        background-color: $main\r\n                        &:nth-of-type(2)\r\n                            background-color: #fff\r\n                        button span p\r\n                            color: #fff\r\n                        button:disabled span p\r\n                            color: #757575\r\n                        button:hover\r\n                            background-color: rgba($accent_r, $accent_g, $accent_b, 0.04)\r\n    h6, svg, span\r\n        color: #fff\r\n    div[role=button]:hover\r\n        background-color: rgba($accent_r, $accent_g, $accent_b, 0.04)\r\n\r\n.cursorPointer\r\n    cursor: pointer\r\n\r\n.withMaterialBorder\r\n    position: relative\r\n    padding: 0 10px\r\n    border-radius: 4px\r\n    border: none\r\n    &:hover\r\n        border-color: rgba($accent_r, $accent_g, $accent_b, 0.5)\r\n    &.active\r\n        border-color: rgba($accent_r, $accent_g, $accent_b, 1)\r\n\r\n\r\n.filterSelect\r\n    .MuiInputBase-root.MuiInput-root\r\n        width: 100%\r\n        max-width: 100%\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `filters_old-container__86itn`,
	"wrap": `filters_wrap__hRtNT`,
	"box": `filters_box__94nP9`,
	"col": `filters_col__PROjd`,
	"row": `filters_row__WeqdW`,
	"text-overflow-hidden": `filters_text-overflow-hidden__2Xu21`,
	"icon": `filters_icon__IV2wh`,
	"richtext-output-wrap": `filters_richtext-output-wrap__wxiiZ`,
	"se-video-container": `filters_se-video-container__9WpzJ`,
	"wrapper": `filters_wrapper__c4mmK`,
	"filterTitle": `filters_filterTitle__P598f`,
	"active": `filters_active__BthXQ`,
	"filterInput": `filters_filterInput__HxdCg`,
	"nibSelectWithSearchInput": `filters_nibSelectWithSearchInput__6Tuex`,
	"search": `filters_search__ZkTTj`,
	"companySelect": `filters_companySelect__hbAqm`,
	"MuiInputBase-root": `filters_MuiInputBase-root__bxSeN`,
	"MuiOutlinedInput-root": `filters_MuiOutlinedInput-root__Xfigs`,
	"MuiAutocomplete-inputRoot": `filters_MuiAutocomplete-inputRoot__acJVe`,
	"date": `filters_date__M9w+N`,
	"dateRange": `filters_dateRange__542OV`,
	"cursorPointer": `filters_cursorPointer__u3qYY`,
	"withMaterialBorder": `filters_withMaterialBorder__QEptV`,
	"filterSelect": `filters_filterSelect__gc09X`,
	"MuiInput-root": `filters_MuiInput-root__sZVzI`
};
export default ___CSS_LOADER_EXPORT___;
